module.exports = __webpack_public_path__ + "static/media/cups.cf93efbe.png";